<div class="request-detail">
  <header class="detail-head">
    <div class="who">
      <nb-user color="#eee" size="medium" [picture]="Globals.logo(request?.employee)" [name]="employeeName(request)"></nb-user>
      <div class="week">
        <span class="week-label">{{ request?.week_start | localedate:'D MMM YYYY' }}</span>
        @if (reviewerNames(request); as reviewers) {
          <span class="reviewers">Reviewers: {{ reviewers }}</span>
        }
      </div>
    </div>
    <span class="status-chip"
          [class.submitted]="request?.status === TrackedStatus.Submitted"
          [class.approved]="request?.status === TrackedStatus.Approved"
          [class.rejected]="request?.status === TrackedStatus.Rejected">{{ statusLabel(request?.status) }}</span>
  </header>

  <!-- Hours Calendar look (timesheet.component.html, desktop calendar), read-only: the week the
       way the employee filled it in, every filled slot in the week's status colour. -->
  <div class="calendar-block">
    <div class="calendar-dates">
      <div class="side">
        <label>{{ 'week' | translate }} {{ weekNumber }}</label>
        <label class="range">{{ days[0] | localedate:'MMM D' }} - {{ days[6] | localedate:'MMM D, YYYY' }}</label>
      </div>
      <blockquote></blockquote>
      @for (day of days; track $index) {
        <div class="day-head">
          <span class="dow">{{ day | localedate:'ddd' }}</span>
          <span class="dates">{{ day | localedate:'MMM DD' }}</span>
        </div>
      }
      <blockquote></blockquote>
      <div class="total"><span class="col-label">Total</span></div>
    </div>
    <div class="calendar-overview">
      <div class="side"></div>
      <blockquote></blockquote>
      @for (sec of dayTotals; track $index) { <div>{{ sec ? duration(sec) : '' }}</div> }
      <blockquote></blockquote>
      <div class="total">{{ duration(totalSeconds(request)) }}</div>
    </div>
    @for (g of groups; track $index) {
      <div class="calendar-project">
        <div class="calendar-project-header">
          <div class="side">
            <span class="proj-dot" [style.background-color]="g.color || 'transparent'"></span>
            <span class="title-item">{{ g.project }}</span>
            @if (g.client) { <span class="client-item">{{ g.client }}</span> }
          </div>
          <blockquote></blockquote>
          @for (sec of g.days; track $index) { <div>{{ sec ? duration(sec) : '' }}</div> }
          <blockquote></blockquote>
          <div class="total">{{ duration(g.total) }}</div>
        </div>
        @for (row of g.rows; track $index) {
          <div class="calendar-project-body">
            <div class="side">
              <span class="desc">{{ row.description || 'No description' }}</span>
              <span class="phase-item">{{ row.phase }}</span>
            </div>
            <blockquote></blockquote>
            @for (sec of row.days; track $index) {
              <div class="weekday" [ngClass]="sec ? cellState : null"><span class="cell">{{ sec ? duration(sec) : '' }}</span></div>
            }
            <blockquote></blockquote>
            <div class="total">{{ duration(row.total) }}</div>
          </div>
        }
      </div>
    }
    <div class="calendar-summary">
      <span>Billable <strong>{{ duration(billableSeconds(request)) }}</strong></span>
      <span>Total <strong>{{ duration(totalSeconds(request)) }}</strong></span>
    </div>
  </div>

  @if (trips.length) {
    <table class="detail-table trips">
      <thead>
        <tr>
          <th>Date</th>
          <th>From</th>
          <th>To</th>
          <th>Project</th>
          <th>Purpose</th>
          <th>Description</th>
          <th class="num">Km</th>
        </tr>
      </thead>
      <tbody>
        @for (trip of trips; track trip.id) {
          <tr>
            <td>{{ trip.driven_on | localedate:'D MMM YYYY' }}</td>
            <td>{{ address(trip, 'from') }}</td>
            <td>{{ address(trip, 'to') }}</td>
            <td>{{ trip.project?.name }}</td>
            <td>{{ trip.purpose === 'commute' ? 'Commute' : 'Business' }}</td>
            <td>{{ trip.description }}</td>
            <td class="num">{{ trip.km }}</td>
          </tr>
        }
      </tbody>
      <tfoot>
        <tr class="grandtotal">
          <td colspan="6">Total km</td>
          <td class="num">{{ tripKm }}</td>
        </tr>
      </tfoot>
    </table>
  }

  @if (request?.events?.length) {
    <div class="events">
      @for (event of request.events; track event.id) {
        <div>
          <span>{{ event.created_at | localedate:'D MMM YYYY HH:mm' }}</span>
          <strong>{{ eventLabel(event.event_type) }}</strong>
          <span>{{ event.actor ? (event.actor.name_first + ' ' + event.actor.name_last) : 'System' }}</span>
          @if (event.reason) { <span class="reason">{{ event.reason }}</span> }
        </div>
      }
    </div>
  }

  @if (canDecide) {
    <footer class="actions">
      <button nbButton status="primary" [disabled]="isLoading" (click)="approve()">
        <nb-icon icon="checkmark-circle-2-outline"></nb-icon>
        <span>Approve</span>
      </button>
      <button nbButton status="danger" ghost [disabled]="isLoading" (click)="reject()">
        <nb-icon icon="close-circle-outline"></nb-icon>
        <span>Reject</span>
      </button>
    </footer>
  }
</div>
